'use client'

import { useCallback, useState } from 'react'

import CornerGradient from '@/components/ui/CornerGradient'

import { cn } from '@/lib/utils'

export default function ChatTileMask({ invert = false }: { invert?: boolean }) {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 })
  const [isHovering, setIsHovering] = useState(false)

  const handleMouseMove = useCallback((e: React.MouseEvent) => {
    const rect = e.currentTarget.getBoundingClientRect()
    setMousePosition({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    })
    setIsHovering(true)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsHovering(false)
  }, [])

  return (
    <div
      className={cn(
        'absolute inset-0 z-0 h-full w-screen overflow-hidden after:pointer-events-none after:absolute after:bottom-0 after:left-0 after:z-30 after:h-20 after:w-full after:bg-gradient-to-t after:to-transparent after:content-[""]',
        {
          'bg-gradient after:from-black': invert,
          'bg-white after:from-white': !invert,
        },
      )}
    >
      {!invert && (
        <>
          <CornerGradient corner="top-left" />
          <CornerGradient corner="top-right" />
          <CornerGradient corner="bottom-left" />
          <CornerGradient corner="bottom-right" />
        </>
      )}

      <div
        className="absolute inset-0 z-0 h-full w-full overflow-hidden transition-opacity duration-300"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        style={{
          backgroundImage: 'url(/img/home/app-tiles.svg)',
          maskImage: `radial-gradient(circle 200px at ${mousePosition.x}px ${mousePosition.y}px, black, transparent)`,
          WebkitMaskImage: `radial-gradient(circle 200px at ${mousePosition.x}px ${mousePosition.y}px, black, transparent)`,
          opacity: isHovering ? 0.6 : 0,
        }}
      ></div>
    </div>
  )
}
